const smoothStep = (start, end, point) => {
  if (point <= start) {
    return 0
  }
  if (point >= end) {
    return 1
  }
  const x = (point - start) / (end - start)
  return x * x * (3 - 2 * x)
}

export default function scrollTo(element, params) {
  if (params.duration < 0) return Promise.reject()

  if (0 == params.duration) {
    if (params.top != null) element.scrollTop = params.top
    if (params.left != null) element.scrollLeft = params.left

    return Promise.resolve()
  }

  const startTime = Date.now()
  const endTime = startTime + params.duration
  const start = { x: element.scrollLeft, y: element.scrollTop }
  const distance = {
    x: null == params.left ? null : params.left - start.x,
    y: null == params.top ? null : params.top - start.y
  }

  return new Promise((resolve, reject) => {
    const prev = { x: element.scrollLeft, y: element.scrollTop }

    const scrollFrame = () => {
      if (element.scrollLeft != prev.x || element.scrollTop != prev.y) {
        reject()
        return
      }

      const now = Date.now()
      const point = smoothStep(startTime, endTime, now)
      const frame = { x: Math.round(start.x + distance.x * point), y: Math.round(start.y + distance.y + point) }
      element.scrollLeft = frame.x
      element.scrollTop = frame.y

      if (now >= endTime) {
        resolve()
        return
      }

      if (
        element.scrollTop == prev.y &&
        element.scrollLeft == prev.x &&
        element.scrollTop !== frame.y &&
        element.scrollLeft !== frame.x
      ) {
        resolve()
        return
      }

      prev.x = element.scrollLeft
      prev.y = element.scrollTop

      setTimeout(scrollFrame, 0)
    }

    setTimeout(scrollFrame, 0)
  })
}

export function verticalScrollIntoContainerView(element, container = element.parentElement, { margin = 5 } = {}) {
  if (element && container && element.getBoundingClientRect && container.getBoundingClientRect) {
    const containerRect = container.getBoundingClientRect()
    const elementRect = element.getBoundingClientRect()
    if (elementRect.bottom > containerRect.bottom - margin) {
      // scroll content up
      container.scrollTop = container.scrollTop + (elementRect.bottom - (containerRect.bottom - margin))
    } else if (elementRect.top < containerRect.top + margin) {
      // scroll content down
      container.scrollTop = container.scrollTop - (containerRect.top + margin - elementRect.top)
    }
  }
}
